import detail from "@/pages/detail/detail";
import info from "@/pages/info/info";
import login from "@/pages/login/login";
import pic from "@/pages/pic/pic";
import Vue from "vue";
import Router from "vue-router";

// import certStatus from '@/pages/cert/certStatus'
// import chooseMode from '@/pages/cert/chooseMode'
// import inputInfo from '@/pages/cert/inputInfo'
// import ads from '@/pages/cert/ads'

const certStatus = () => import("@/pages/cert/certStatus");
const chooseMode = () => import("@/pages/cert/chooseMode");
const inputInfo = () => import("@/pages/cert/inputInfo");
const ads = () => import("@/pages/cert/ads");
const wxlogin = () => import("@/pages/wxlogin");
const checkIn = () => import("@/pages/checkin");
const video = () => import("@/pages/video");
const success = () => import("@/pages/success");
const download = () => import("@/pages/download");
const test = () => import("@/pages/test");
const attendance = () => import("@/pages/cert/attendance");
const team = () => import("@/pages/cert/team");
const shareVip = () => import("@/pages/cert/sharevip");
const protocol = () => import("@/pages/cert/protocol");
// const info = () => import('@/pages/info/info')

Vue.use(Router);

export default new Router({
  routes: [
    {
      path: "/",
      name: "login",
      component: login
    },
    {
      path: "/wxlogin",
      name: "wxlogin",
      component: wxlogin
    },
    {
      path: "/checkin",
      name: "checkin",
      component: checkIn
    },
    {
      path: "/success",
      name: "success",
      component: success
    },
    {
      path: "/test",
      name: "test",
      component: test
    },
    {
      path: "/download",
      name: "download",
      component: download
    },
    {
      path: "/video",
      name: "video",
      component: video
    },
    {
      path: "/detail",
      name: "detail",
      component: detail
    },
    {
      path: "/info",
      name: "info",
      component: info
    },
    {
      path: "/pic",
      name: "pic",
      component: pic
    },
    {
      path: "/cert/certstatus",
      name: "certStatus",
      component: certStatus,
      meta: { title: "认证状态页" }
    },
    {
      path: "/cert/attendance",
      name: "attendance",
      component: attendance,
      meta: { title: "立吉拍照认证" }
    },
    {
      path: "/cert/team",
      name: "team",
      component: team
    },
    {
      path: "/cert/sharevip",
      name: "sharevip",
      component: shareVip
    },
    {
      path: "/cert/protocol",
      name: "protocol",
      component: protocol,
      meta: { title: "立吉拍照服务协议" }
    },
    {
      path: "/cert/choosemode",
      name: "chooseMode",
      component: chooseMode,
      meta: { title: "选择模式" }
    },
    {
      path: "/cert/inputinfo",
      name: "inputInfo",
      component: inputInfo,
      meta: { title: "填信息" }
    },
    {
      path: "/cert/ads",
      name: "ads",
      component: ads,
      meta: { title: "屏蔽广告" }
    }
  ],
  mode: "history", //后端支持可开
  // 线上测试环境要加这个，正式环境不加这个
  // base: '/test/',
  scrollBehavior: () => ({ y: 0 })
});



// WEBPACK FOOTER //
// ./src/router/index.js